export {default} from "./Chips-component"